import { inject, Injectable } from '@angular/core';
import { DashboardProfileContextService } from '@rma/dashboard/authentication/public/user';
import { rmaShareReplay } from '@rma/generic/rxjs/operators/rma-share-replay';
import { map, Observable, switchMap } from 'rxjs';
import { SearchReviewsApiService } from './search-reviews-api.service';

@Injectable({
  providedIn: 'root',
})
export class SearchReviewsService {
  private readonly searchReviewsApiService = inject(SearchReviewsApiService);
  private readonly profileContextService = inject(DashboardProfileContextService);

  public getProfileReviewCount(from: Date): Observable<number> {
    // TODO Create a new end-point to retrun just Review Count, instead of bring back whole data which is not need it
    return this.profileContextService.profileIdentifier$.pipe(
      switchMap(({ profileCode, profileType }) =>
        this.searchReviewsApiService
          .searchReviews({
            from: from,
            statuses: ['Active', 'Requested'],
            profiles: [{ profileCode, profileType }],
          })
          .pipe(map((reviews) => reviews.total)),
      ),
      rmaShareReplay(),
    );
  }
}
